import { Component, computed } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TemplateFilterDto, TemplateItemDto, TemplateService } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { currentTenantId } from '@/utils/admin-utils';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-template-overview-page',
  templateUrl: './template-overview-page.component.html',
  styleUrls: ['./template-overview-page.component.scss']
})
export class TemplateOverviewPageComponent {
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTemplates'));

  tenantId = currentTenantId();

  readonly loadTemplates = (filter: TemplateFilterDto) => this.templateService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: TemplateFilterDto) => this.templateService.getCount({ ...filter, tenantId: this.tenantId() });

  form!: FormGroup;

  constructor(
    private readonly templateService: TemplateService,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  add(): void {
    this.router.navigate(['template', 'new']);
  }

  navigateToTemplate(event: TemplateItemDto): void {
    this.router.navigate(['template', event.id]);
  }
}
